export default "__VITE_ASSET__a9a31284__"